module.exports = __webpack_public_path__ + "static/media/onollo-purple-circle.cfbd568a.svg";